module.exports = __webpack_public_path__ + "static/img/itms.9982044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/itms.png
// module id = CcGo
// module chunks = 0